import { formikField } from '@sainsburys-tech/luna-form/extensions/formik'

import { LabelledText } from 'src/components/Form'

export default formikField(LabelledText)
